import * as React from "react";
import PropTypes from "prop-types";
import "./Style.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import decisionMakerImage from "../../../../Assets/Cloudfigma.svg";
import axios from "axios";
import { toast } from "react-toastify";
import {
  APISalesforceUrl,
  APIDataUrl,
  APITokenUrl,
  APIGraphUrl,
  GetOktaAuthData,
  GetUserId,
} from "../../../../Utils/Utils";
import { useLocation, useNavigate } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import * as XLSX from "xlsx";
import crieboxestwo from "../../../../Assets/crieboxesbtntwo.svg";
import linkedin from "../../../../Assets/linkedin.svg";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import phone from "../../../../Assets/phone.svg";
import sortingimg from "../../../../Assets/sortingarrow.svg";
import SouthIcon from "@mui/icons-material/South";
import NorthIcon from "@mui/icons-material/North";
import activeSaleforceLogo from "../../../../Assets/activeSaleforceLogo.svg";

function Row({ row, setValue, setCrieNavigate }) {
  const navigate = useNavigate();
  return (
    <>
      <TableRow>
        <TableCell style={{ pageBreakInside: "avoid" }}>
          <div className="first_crie_box-cards">
            <div className="inner-card-criesale">
              <div
                onClick={() =>
                  row?.id && navigate(`/Profile/${row?.person_id}`)
                }
                className={
                  row?.decision_maker === true
                    ? "Decision-maker-user-name-cards"
                    : "Decision-maker-user-namenoborder-cards"
                }
              >
                <img
                  className={
                    row?.suspect_status === null
                      ? "hide-image"
                      : "decisionMakerImage-new-cards"
                  }
                  src={
                    row?.journey_status === "project created"
                      ? activeSaleforceLogo
                      : decisionMakerImage
                  }
                  alt=""
                />
                <p className="letter-heading">
                  {row?.first_name?.substring(0, 1)}
                  {row?.last_name?.substring(0, 1)}
                </p>
              </div>
              <div className="crie_info-cards">
                <div className="crie_name-cards">
                  <p
                    className="crie_name-cards-names"
                    onClick={() =>
                      row?.id && navigate(`/Profile/${row?.person_id}`)
                    }
                  >
                    {" "}
                    {row?.first_name} {row?.last_name}
                  </p>{" "}
                  <p>{row?.strengthData?.strength}</p>
                </div>
                <div style={{ cursor: "pointer" }}>
                  {row?.primary_job_title}
                </div>
                <div style={{ cursor: "pointer" }}>
                  {row?.primary_organization}
                </div>
                <a
                  className="company-profile-mention-linkedin"
                  target="_blank"
                  href={row?.email ? `mailto:${row.email}` : undefined}
                  style={{
                    textDecoration: row?.email ? "underline" : "none",
                    cursor: row?.email ? "pointer" : "default",
                  }}
                >
                  <EmailOutlinedIcon
                    style={{
                      color: "#003057",
                      width: "15px",
                      height: "15px",
                    }}
                  />
                  {row?.email
                    ? row.email.split(",")[0].length > 18
                      ? row.email.split(",")[0].substring(0, 18) + "..."
                      : row.email.split(",")[0]
                    : "--"}
                </a>
                <a className="company-profile-mention">
                  <img
                    src={phone}
                    alt=""
                    style={{ width: "13px", height: "13px" }}
                  />
                  {row?.phone_no || "--"}
                </a>
                <p className="company-profile-mention-2">
                  <span>
                    <img
                      src={linkedin}
                      alt=""
                      style={{ width: "14px", height: "14px" }}
                    />
                    <a
                      className="company-profile-mention-linkedin"
                      href={row?.linkedin}
                      target="_blank"
                    >
                      {row?.linkedin
                        ? row?.linkedin.split("https://www.linkedin.com/in/")[1]
                            ?.length > 18
                          ? row?.linkedin
                              .split("https://www.linkedin.com/")[1]
                              .substring(0, 18) + "..."
                          : row?.linkedin.split("https://www.linkedin.com/")[1]
                        : "--"}
                    </a>
                  </span>
                </p>
                <div className="d-connections-card">
                  <p className="connections-num">
                    {row?.direct_connection_count
                      ? row?.direct_connection_count
                      : 0}
                  </p>

                  <p
                    onClick={() => {
                      setValue(1);
                      setCrieNavigate(row?.person_id);
                    }}
                  >
                    Direct Connections
                  </p>
                </div>
              </div>
            </div>
          </div>
        </TableCell>
      </TableRow>
    </>
  );
}

Row.propTypes = {
  row: PropTypes.object.isRequired,
  selected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
};
export default function EmployeesTablePdf({
  selectedOuterRows,
  setSelectedOuterRows,
  tableCommingData,
  setCurrentLeadsLength,
  dataForInformation,
  setIsSalesForceTrigger,
  isSalesForceTrigger,
  rowData,
  setDisableRequestUpdate,
  requestUpdateRecord,
  setRequestUpdateRecord,
  setLeadsRequestModal,
  setShowSalesForce,
  setValue,
  setCrieNavigate,
}) {
  const userInfo = GetOktaAuthData();
  const loggedInUserId = GetUserId();

  const loggedUser = userInfo?.user?.profile;
  const location = useLocation();
  const isComponyScreen = location?.state?.isComponyScreen;
  const [previousState, setPreviousState] = React.useState(false);
  React.useEffect(() => {
    if (isComponyScreen) {
      setPreviousState(true);
    }
  }, [isComponyScreen]);
  const [decisionMakerData, setDecisionMakerData] = React.useState([]);
  const [decisionMakerDataCompany, setDecisionMakerDataCompany] =
    React.useState([]);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [strengthTableData, setStrengthTableData] = React.useState([]);
  const decisionMakerTableData = decisionMakerData;
  const [hasMore, setHasMore] = React.useState(false);
  const [skip, setSkip] = React.useState(0);
  const [decisionMakerDataCount, setDecisionMakerDataCount] =
    React.useState("");
  const [rowsSelect, setRowsSelect] = React.useState({});
  const [favoritesList, setFavoritesList] = React.useState([]);
  const [archivesList, setArchivesList] = React.useState([]);
  const [requestUpdateModal, setRequestUpdateModal] = React.useState(false);
  const [messageModalSalesforce, setMessageModalSalesforce] =
    React.useState(false);
  const [showCrieBoxes, setShowCrieBoxes] = React.useState(false);

  const [data, setData] = React.useState([]);
  const [sortField, setSortField] = React.useState("");
  const [sortOrder, setSortOrder] = React.useState(null);

  const handleCrieBoxesClose = () => {
    setShowCrieBoxes(false);
  };
  const getStrength = async () => {
    if (!decisionMakerTableData?.length && !decisionMakerDataCompany?.length)
      return;
    const tuples = decisionMakerDataCompany?.length
      ? decisionMakerDataCompany.map((item) => ({
          items: [loggedInUserId?.toString(), item?.person_id?.toString()],
        }))
      : decisionMakerTableData.map((item) => ({
          items: [loggedInUserId?.toString(), item?.person_id?.toString()],
        }));
    const data = { tuples };
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      data: data,
      url: `${APIGraphUrl()}/v1/conn_strength`,
    };
    try {
      const response = await axios(options);
      const strengthData = response?.data;
      let updatedData = [];
      if (decisionMakerDataCompany?.length) {
        updatedData = decisionMakerDataCompany?.map((item, index) => ({
          ...item,
          strengthData: strengthData[index],
        }));
      } else {
        updatedData = decisionMakerTableData?.map((item, index) => ({
          ...item,
          strengthData: strengthData[index],
        }));
      }

      setStrengthTableData(updatedData);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
    }
  };
  React.useEffect(() => {
    getStrength();
  }, [decisionMakerTableData, decisionMakerDataCompany]);

  // const fetchMoreData = () => {
  //     if (!decisionMakerData?.length && !decisionMakerDataCompany?.length) return;
  //     const hasMore =
  //         decisionMakerDataCompany?.length?.length < rowData?.people_count ||
  //         decisionMakerData?.length < rowData?.people_count ||
  //         decisionMakerDataCount;
  //     if (!hasMore) return;
  //     setSkip((prevskip) => prevskip + 50);
  // };
  // React.useEffect(() => {
  //     setSkip(0);
  //     setDecisionMakerData([]);
  //     setDecisionMakerDataCompany([]);
  // }, [dataForInformation]);

  const aiDecisionMakerTableCompany = (eventName) => {
    setHasMore(false);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/decision_maker?org_id=${rowData}&limit=50&skip=${
        eventName ? 0 : skip
      }`,
    };
    axios(option)
      .then((e) => {
        setDecisionMakerDataCount(e?.data?.count);
        const comingData = e?.data?.data;

        if (comingData.length === 0) {
          setHasMore(false);
          setDecisionMakerDataCompany([]);
          setStrengthTableData([]);
        } else {
          if (comingData.length % 50 === 0)
            setTimeout(() => setHasMore(true), 1000);
          decisionMakerDataCompany.length === 0 || eventName
            ? setDecisionMakerDataCompany(comingData)
            : setDecisionMakerDataCompany([
                ...decisionMakerDataCompany,
                ...comingData,
              ]);
        }
      })
      .catch(() => {});
  };
  const aiDecisionMakerTable = (eventName) => {
    setHasMore(false);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/decision_maker?org_id=${rowData}&limit=50&skip=${skip}`,
    };
    axios(option)
      .then((e) => {
        setDecisionMakerDataCount(e?.data?.count);
        const comingData = e?.data?.data;

        if (comingData.length === 0) {
          setHasMore(false);
          setDecisionMakerData([]);
          setStrengthTableData([]);
        } else {
          if (comingData.length % 50 === 0)
            setTimeout(() => setHasMore(true), 1000);
          decisionMakerData.length === 0
            ? setDecisionMakerData(comingData)
            : setDecisionMakerData([...decisionMakerData, ...comingData]);
        }
      })
      .catch(() => {});
  };

  React.useEffect(() => {
    if (dataForInformation) {
      if (previousState) {
        aiDecisionMakerTableCompany();
      } else {
        aiDecisionMakerTable();
      }
    }
  }, [dataForInformation]);
  React.useEffect(() => {
    if (tableCommingData) {
      setCurrentLeadsLength(tableCommingData?.length);
    }
  }, [tableCommingData]);

  React.useEffect(() => {
    if (decisionMakerDataCompany?.length >= 50) {
      aiDecisionMakerTableCompany();
    } else if (decisionMakerData?.length >= 50) {
      aiDecisionMakerTable();
    }
  }, [skip]);

  React.useEffect(() => {
    if (selectedOuterRows?.length < 1 && requestUpdateRecord == true) {
      setDisableRequestUpdate(false);
      setLeadsRequestModal(true);
    } else if (selectedOuterRows?.length === 1 && requestUpdateRecord == true) {
      setRequestUpdateModal(true);
      setRequestUpdateRecord(false);
      setDisableRequestUpdate(false);
    } else if (selectedOuterRows?.length > 1 && requestUpdateRecord == true) {
      setDisableRequestUpdate(false);
      setRequestUpdateRecord(false);
      toast.error("Please select only one record to request update");
    } else {
      setDisableRequestUpdate(false);
    }
  }, [selectedOuterRows, requestUpdateRecord]);

  const validateSalesforce = () => {
    if (!selectedOuterRows || selectedOuterRows?.length === 0) {
      toast.error("Please Select Records For Push To Salesforce");
      setIsSalesForceTrigger(false);
      return false;
    }
    return true;
  };

  React.useEffect(() => {
    setData(strengthTableData);
  }, [strengthTableData]);

  React.useEffect(() => {
    const sortedDataDefault = strengthTableData
      ?.filter(
        (item) => !archivesList?.some((i) => i?.person_id === item?.person_id)
      )
      ?.sort((a, b) => {
        if (a.decision_maker && !b.decision_maker) return -1;
        if (!a.decision_maker && b.decision_maker) return 1;
        return (
          (b.strengthData?.strength || 0) - (a.strengthData?.strength || 0)
        );
      });
    setData(sortedDataDefault);
  }, [strengthTableData, archivesList]);

  const handleSort = (field) => {};
  return (
    <>
      {strengthTableData?.length ? (
        <TableContainer
          component={Paper}
          className={showCrieBoxes ? "" : "DecisionMaker-table-main"}
        >
          <Table aria-label="collapsible table" className="DecisionMaker-table">
            <div className="table-row-ai-leads-cards">
              <div className="titlescards-emp-table">
                <p>
                  Name{" "}
                  {sortField === "first_name" ? (
                    sortOrder === "asc" ? (
                      <NorthIcon
                        className="up-down-arrows-sorting"
                        onClick={() => handleSort("first_name")}
                      />
                    ) : (
                      <SouthIcon
                        className="up-down-arrows-sorting"
                        onClick={() => handleSort("first_name")}
                      />
                    )
                  ) : (
                    <img
                      src={sortingimg}
                      alt=""
                      onClick={() => handleSort("first_name")}
                      className="sorting-arrow-leadsprofile"
                      style={{ cursor: "pointer" }}
                    />
                  )}
                </p>
                <p>
                  Orbit Strength{" "}
                  {sortField === "strengthData.strength" ? (
                    sortOrder === "asc" ? (
                      <NorthIcon
                        className="up-down-arrows-sorting"
                        onClick={() => handleSort("strengthData.strength")}
                      />
                    ) : (
                      <SouthIcon
                        className="up-down-arrows-sorting"
                        onClick={() => handleSort("strengthData.strength")}
                      />
                    )
                  ) : (
                    <img
                      src={sortingimg}
                      alt=""
                      onClick={() => handleSort("strengthData.strength")}
                      className="sorting-arrow-leadsprofile"
                      style={{ cursor: "pointer" }}
                    />
                  )}
                </p>

                <p>
                  Orbit Status{" "}
                  {sortField === "suspect_status" ? (
                    sortOrder === "asc" ? (
                      <NorthIcon
                        className="up-down-arrows-sorting"
                        onClick={() => handleSort("suspect_status")}
                      />
                    ) : (
                      <SouthIcon
                        className="up-down-arrows-sorting"
                        onClick={() => handleSort("suspect_status")}
                      />
                    )
                  ) : (
                    <img
                      src={sortingimg}
                      alt=""
                      onClick={() => handleSort("suspect_status")}
                      className="sorting-arrow-leadsprofile"
                      style={{ cursor: "pointer" }}
                    />
                  )}
                </p>
              </div>
            </div>

            <TableBody className="crieboxes-emptable-pdf">
              {data?.map((row, index) => (
                <React.Fragment key={index}>
                  <Row
                    row={row}
                    selected={selectedRows.includes(row.first_name)}
                    onSelect={(firstName) => {
                      const selectedIndex = selectedRows.indexOf(firstName);
                      let newSelected = [];
                      if (selectedIndex === -1) {
                        newSelected = newSelected.concat(
                          selectedRows,
                          firstName
                        );
                      } else if (selectedIndex === 0) {
                        newSelected = newSelected.concat(selectedRows.slice(1));
                      } else if (selectedIndex === selectedRows.length - 1) {
                        newSelected = newSelected.concat(
                          selectedRows.slice(0, -1)
                        );
                      } else if (selectedIndex > 0) {
                        newSelected = newSelected.concat(
                          selectedRows.slice(0, selectedIndex),
                          selectedRows.slice(selectedIndex + 1)
                        );
                      }
                      setSelectedRows(newSelected);
                    }}
                    setRowsSelect={setRowsSelect}
                    selectedOuterRows={selectedOuterRows}
                    favoritesList={favoritesList}
                    setFavoritesList={setFavoritesList}
                    // listFavoriteRecords={listFavoriteRecords}
                    showCrieBoxes={showCrieBoxes}
                    setValue={setValue}
                    setCrieNavigate={setCrieNavigate}
                    aiDecisionMakerTableCompany={aiDecisionMakerTableCompany}
                  />
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <div className="ai-leads-table-main">
          <div className="ai-leads-no-data-available-outter">
            <div className="ai-leads-no-data-available">No Data Available</div>
          </div>
        </div>
      )}
    </>
  );
}
